import { useOutletContext, Navigate } from "react-router-dom";
import Maintenance from "../../components/Maintenance";

const MaintenancePage = () => {
  const { agent } = useOutletContext();

  // Only tenant_admin can access this page
  if (agent?.role !== "tenant_admin") {
    return <Navigate to="/admin" replace />;
  }

  return (
    <div className="h-full overflow-y-auto p-6">
      <Maintenance agent={agent} />
    </div>
  );
};

export default MaintenancePage;
